export function target() {
  return ['SimpleText'].includes(this.module);
}

export function migrate() {
  if (this.module === 'SimpleText') {
    this.module = 'BackgroundText';
    this.name = 'Texto com fundo';
  }
  this.data.localSecondaryColor = this.data.buttonColor;
}
